import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import AnimationImage from "../assets/img/Big-planet_transparent gif.gif";
import StarIcon from "../assets/img/star-1-9.svg";
import DotsImage from "../assets/img/dots-5.svg";

const SectionEight = () => {
  return (
    <section id="whyus" className="enterprise-messaging-section-eight">
      <Container>
        <div className="py-5 overflow-hidden">
          <Col lg={7} className="mx-auto text-center overflow-hidden">
            <p className="display-5 fw-normal">
              <strong className="gradient-text">WHY US</strong> <br />
            </p>
          </Col>
        </div>
        <Row className="justify-content-center">
          <Col md={4} className="carousal-item-spacing">
            <div className="text-left mt-5 mt-5-why-us">
              <ul className="list-unstyled" >
                <li className="mb-4 no-indent">
                  <div className="d-flex align-items-center mb-2">

                  <Image src={StarIcon} alt="Star Icon" fluid />
                  <strong className="gradient-text-why-us">Neutral & Operator-Centric by Design</strong>
                  </div>
                  <p className="mb-0">
                    Digi-Touch operates with no ownership in mobile networks, ensuring
                    complete neutrality. This allows us to act solely in the best interest
                    of mobile operators, enabling secure infrastructure monetization
                    without competitive conflict or commercial bias.
                  </p>
                </li>
                <li className="mb-4 no-indent">
                  <div className="d-flex align-items-center mb-2">

                  <Image src={StarIcon} alt="Star Icon" fluid />
                  <strong className="gradient-text-why-us">Digital Enablement Beyond Messaging</strong>
                  </div>
                  <p className="mb-0">
                    We go beyond aggregation. Digi-Touch enables mobile operators with
                    scalable digital platforms, including API exposure and data-driven services,
                    helping them participate more effectively in the digital ecosystem
                    and unlock new revenue streams.
                  </p>
                </li>
                <li className="mb-4 no-indent">
                  <div className="d-flex align-items-center mb-2">

                  <Image src={StarIcon} alt="Star Icon" fluid />
                  <strong className="gradient-text-why-us">
                    Flexible System Integration & Best-Fit Solutions
                  </strong>
                  </div>
                  <p className="mb-0">
                    Digi-Touch specializes in integrating with existing operator environments,
                    platforms, and ecosystems. We design and deploy solutions that are best
                    suited to each customer’s technical, commercial, and regulatory requirements—ensuring
                    seamless integration, faster time-to-market, and long-term scalability.
                  </p>
                </li>
              </ul>
            </div>
          </Col>
          <Col md={4} className="carousal-item-spacing">
            <div className="text-left mt-5 mt-5-why-us">
              <ul className="list-unstyled" >
                <li className="mb-4 no-indent">
                  <div className="d-flex align-items-center mb-2">   {/* This controls spacing */}
                    <Image src={StarIcon} alt="Star Icon" fluid />
                    <strong className="gradient-text-why-us">
                      Secure, Compliant & Scalable Platforms
                    </strong>
                  </div>

                  <p className="mb-0">
                    Security and compliance are at the core of everything we do. Our
                    solutions are designed to meet regulatory requirements, prevent
                    fraud, and scale efficiently, allowing operators to grow confidently
                    in an increasingly complex digital environment.
                  </p>
                </li>
                <li className="mb-4 no-indent">
                  <div className="d-flex align-items-center mb-2">
                  <Image src={StarIcon} alt="Star Icon" fluid />
                  <strong className="gradient-text-why-us">
                    Managed Services, Simplified Operations
                  </strong>
                  </div>
                  <p className="mb-0">
                    Digi-Touch delivers fully managed services, reducing operational
                    complexity for mobile operators. From onboarding and monitoring to
                    optimization and reporting, we handle the day-to-day operations
                    so our partners can focus on strategic growth.
                  </p>
                </li>
                <li className="mb-4 no-indent">
                  <div className="d-flex align-items-center mb-2">

                  <Image src={StarIcon} alt="Star Icon" fluid />
                  <strong className="gradient-text-why-us">
                    Connecting Operators and Enterprises
                  </strong>
                  </div>
                  <p className="mb-0 why-us-p">
                    By bridging mobile networks with the digital world, Digi-Touch
                    enables enterprises with trusted connectivity and reach, while
                    ensuring mobile operators maintain control, visibility, and value
                    over their messaging and digital channels.
                  </p>
                </li>
              </ul>
            </div>
          </Col>
          <Col
            md={4}
            className="d-flex justify-content-center align-items-center"
          >
            <div>
              <Image
                src={AnimationImage}
                alt="Enterprise SMS"
                className=""
                fluid
              />
            </div>
          </Col>
        </Row>
      </Container>
      {/*<div className="dots-image-container">*/}
      {/*  <div id="products" className="dot-background">*/}

      {/*  </div>*/}
      {/*</div>*/}
    </section>
  );
};

export default SectionEight;
